// English translation

const en = {
  "menu.housekeeping": "HOUSEKEEPING",
  "hotel.room": "HOUSEKEEPING",
  "hotel.room.current_guests": "Current Guest",
  "hotel.room.state": "STATE",
  "hotel.room.name": "ROOM",
  "hotel.room.cleaning_type": "CLEANING TYPE",
  "hotel.room.dirty": "Dirty",
  "hotel.room.clean": "Clean",
  "hotel.room.inspected": "Inspected",
  "hotel.room.not_authorized": "No Author.",
  "hotel.room.all": "ALL",
  "hotel.room.maintenance": "Maintenance",
  "hotel.room.location": "Location",
  "hotel.room.check_out_today": "Check Out Today",
  "hotel.room.arrival_today": "Arrival Today",
  "hotel.room.check_in_today": "Check In Today",
  "hotel.room.departure_today": "Departure Today",
  "hotel.room.housekeeping": "Housekeeping",
  "hotel.room.type_": "Type",
  "hotel.room.occupied_today": "Ocupadas Hoy",
  "housekeeping.wizard_schedule.reset_all": "Delete All The Schedule",
  "hotel.room.type_.filter": "Type Filter",
  "schedule.wizard_schedule.title": "Housekeeping Schedule ",
  "schedule.wizard_schedule.create": "Create Schedule",
  "schedule.wizard_schedule.save": "Save",
  "schedule.wizard_schedule.close": "Close",
  "hotel.room.locations": "LOCATIONS",
  "hotel.room.tweak": "Tweak",
  "hotel.room.deep": "Deep",
  "hotel.room.standard": "Standard",
  "hotel.room.occupied": "Occupied",
  "hotel.room.vacancy": "Vacancy",
  "hotel.room.departure": "Departure",
  "hotel.housekeeping.msg_now_room_is_dirty": "Now room is dirty!",
  "hotel.housekeeping.msg_now_room_is_clean": "Now room is clean!",
  "hotel.housekeeping.msg_now_room_is_maintenance": "Now room is maintenance!",
  "hotel.housekeeping.msg_now_room_is_not_auth":
    "Now room is checked not not_authorized!",
};

export default en;
